export const EMAIL_ID = 'Sm.sohan586@gmail.com';
export const WEBSITE_LINK = '';

export const RESUME_LINK = 'https://drive.google.com/file/d/1Yc6-Xm4ZLH8L-dZOBHZv-pTmTA82u-2M/view?usp=sharing';
export const GITHUB_LINK = 'https://github.com/SaifuddinGsohan';
export const LINKEDIN_LINK = 'https://www.linkedin.com/in/saifuddin-sohan';
export const FACEBOOK_LINK = 'https://facebook.com/SaifuddinFsohan';
export const INSTAGRAM_LINK = 'https://www.instagram.com/saifuddin_sohan';
export const TWITTER_LINK = 'https://twitter.com/SaifuddinTsohan';

export const G_RECAPTA_TOKEN = "6Le3bVgfAAAAAOyzttvy7JAwcIKiYg7AXRL2mMpP";